import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Button, } from "reactstrap";
import { Form, Formik } from 'formik';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import '../../../assets/css/pages/TextReport.css'
import { AddReportImgRes, AddReportImgTodo } from 'redux/slice/admin/text-report/TextReportImg';
import { toast, ToastContainer } from 'react-toastify';
import SelectInput from 'components/input-field/SelectInput';
import { DoctorListRes, DoctorListTodo } from 'redux/slice/admin/doctor/DoctorList';
import { PatientListTodo } from 'redux/slice/admin/patient/PatientList';
import { ReportSchema } from './Validation';
import DetectDiseaseForm from './DetectDiseaseForm';
import PossibleDisease from './PossibleDisease';
import { values } from 'lodash';
import { TestListTodo } from 'redux/slice/admin/text-report/TestList';
import Loader from 'components/loader/Loader';


class BloodTextReport extends Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();

        this.state = {
            file: null, // Single file state,
            reportRes: '',
            predictionsRes: null,
            testtypeval: '',
            capturedImage: null,
            fileImage: null,
            values: {
                doctor: '',
                patient: '',
                type: '',
                test_url: '',
                imgFile: '',
                captureImg: ""

            }
        };


    }

    updateState = (newData) => {
        // console.log("newData", newData)
        this.setState({ predictionsRes: newData });
    };

    captureImage = (setFieldValue) => {


        const video = this.videoRef.current;
        const canvas = this.canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageDataUrl = canvas.toDataURL("image/png");

        this.setState({ capturedImage: imageDataUrl });
        setFieldValue('captureImg', imageDataUrl)

    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        dispatch(DoctorListTodo()).then(() => this.listRes())

        // dispatch(TestListTodo())
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then((stream) => {
                    this.videoRef.current.srcObject = stream;
                })
                .catch((error) => {
                    console.error("Error accessing webcam:", error);
                });
        } else {
            console.error("getUserMedia not supported in this browser.");
        }
    }

    listRes = () => {
        const { dispatch } = this.props;
        if (DoctorListRes?.success) {
            this.setState({ loading: false });
            dispatch(PatientListTodo()).then((patient_res) => {
                if (patient_res?.payload?.success) {
                    this.setState({ loading: false });
                    dispatch(TestListTodo()).then((test_res) => {
                        if (test_res?.payload?.success) {
                            this.setState({ loading: false });
                        } else if (test_res?.payload?.error?.status == 401) {
                            localStorage.clear()
                            this.props.history.push('/admin/login');
                        } else {
                            this.setState({ loading: false });
                        }
                    })
                } else if (patient_res?.payload?.error?.status == 401) {
                    localStorage.clear()
                    this.props.history.push('/admin/login');
                } else {
                    this.setState({ loading: false });
                }
            })
        } else if (DoctorListRes?.error?.status == 401) {
            localStorage.clear()
            this.props.history.push('/admin/login');
        } else {
            this.setState({ loading: false });
        }
        this.setState({ loading: false });
    }

    add_res = (setFieldValue) => {

        if (AddReportImgRes?.success) {
            toast.success(AddReportImgRes?.message, { position: "bottom-right" });
            this.setState({
                reportRes: AddReportImgRes  // or you can merge if reportRes is an array or object
            });
            this.setState({ spiner: false });
            setFieldValue('captureImg', '');
            setFieldValue('imgFile', '');


        } else {
            toast.error(AddReportImgRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }

    handleImageChange = (e, setFieldValue) => {
        const file = e.target.files[0];

        if (file) {
            // this.setState({ fileImage: file }); // Set the file in state
            this.setState({ fileImage: URL.createObjectURL(file) });
            setFieldValue("imgFile", file); // Also set the file in Formik's field value
            setFieldValue("capturedImage ", ''); // Also set the file in Formik's field value
        }
    };

    render() {
        const { file } = this.state; // Destructure file from state
        const { reportRes, predictionsRes } = this.state;
        const { DoctorList, PatientList, TestList } = this.props;


        const docterOption = DoctorList && DoctorList.map(val => (
            { "value": val.id, "label": val.name }
        ))
        const patientOption = PatientList && PatientList.map(val => (
            { "value": val.id, "label": val.name }
        ))

        const testTypeOption = TestList && TestList.map(val => (
            { "value": val.id, "label": val.test_name, "value2": val.url_name }
        ))

        const { capturedImage } = this.state;
        const { fileImage } = this.state;

        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <h4 className="mb-0 font-size-18"> Microscope Test</h4>

                        {this.state.loading ?
                            <div className='d-flex justify-content-center mt-5'>
                                <Loader />
                            </div> :
                            <Row>
                                <Col xl='12'>
                                    <div className='form_layout'>
                                        <Formik
                                            initialValues={this.state.values}
                                            validationSchema={ReportSchema}
                                            onSubmit={(values, { setFieldValue }) => {
                                                console.log(values)
                                                this.setState({ spiner: true });
                                                const { dispatch } = this.props;

                                                let bodyFormData = new FormData();
                                                bodyFormData.append("doctor_id", values.doctor);
                                                bodyFormData.append("patient_id", values.patient);
                                                bodyFormData.append("test_type", values.type);
                                                bodyFormData.append("test_url", values.test_url);
                                                bodyFormData.append("company_id", localStorage.getItem('companyId'));
                                                bodyFormData.append("image_b", values.captureImg ? values.captureImg : '');
                                                bodyFormData.append("path", "report");
                                                bodyFormData.append("reportImage", values.imgFile ? values.imgFile : '');

                                                // Dispatch action and call add_res with setFieldValue
                                                dispatch(AddReportImgTodo(bodyFormData)).then(() => this.add_res(setFieldValue));
                                            }
                                            }
                                        >
                                            {({
                                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                                <Form>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <SelectInput
                                                                        closeMenu={true}
                                                                        label_name='Select Doctor'
                                                                        disabled={false}
                                                                        options={docterOption}
                                                                        name='doctor'
                                                                        defaultValue={''}
                                                                        onChange={(e) =>
                                                                            setFieldValue('doctor', e.value)
                                                                        }
                                                                        onBlur={handleBlur}
                                                                        error={errors.doctor && touched.doctor ? (<span className='text-danger form_label' >{errors.doctor}</span>) : null}
                                                                    />
                                                                </div>
                                                                {/* <div className="col-md-12"> */}
                                                                <input type="hidden" name='captureImg' />
                                                                {/* </div> */}
                                                                <div className="col-md-6">
                                                                    <SelectInput
                                                                        closeMenu={true}
                                                                        label_name='Select Patient'
                                                                        disabled={false}
                                                                        options={patientOption}
                                                                        name='patient'
                                                                        defaultValue={''}
                                                                        onChange={(e) =>
                                                                            setFieldValue('patient', e.value)
                                                                        }
                                                                        onBlur={handleBlur}
                                                                        error={errors.patient && touched.patient ? (<span className='text-danger form_label' >{errors.patient}</span>) : null}
                                                                    />
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <SelectInput
                                                                        closeMenu={true}
                                                                        label_name='Test Type'
                                                                        disabled={false}
                                                                        options={testTypeOption}
                                                                        name='type'
                                                                        defaultValue={''}
                                                                        onChange={(e) => {

                                                                            this.setState({
                                                                                testtypeval: e.value
                                                                            });
                                                                            setFieldValue('type', e.value);
                                                                            setFieldValue('test_url', e.value2);

                                                                        }
                                                                        }
                                                                        onBlur={handleBlur}
                                                                        error={errors.type && touched.type ? (<span className='text-danger form_label' >{errors.type}</span>) : null}
                                                                    />
                                                                </div>
                                                                {values.captureImg || values.imgFile ? <div className="col-md-12 text-end">
                                                                    <button className="btn add_btn btn-block ps-3 pe-3 " type="submit" disabled={this.state.spiner ? true : false} >
                                                                        {this.state.spiner ? <> <span className='pe-1'>Loading....</span>  <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                                        </> : <span > Genrate Report </span>}
                                                                    </button>
                                                                </div> : ''}

                                                                {
                                                                    reportRes?.data ?
                                                                        <div className="col-md-12">
                                                                            {reportRes?.type === 1 ?
                                                                                <DetectDiseaseForm predictionsRes={predictionsRes} updateState={this.updateState} reportRes={reportRes?.data} testtypeval={this.state.testtypeval} />
                                                                                :
                                                                                <div className='output_sec'>
                                                                                    <h1>{reportRes?.data?.prediction}</h1>
                                                                                    <h2>{reportRes?.data?.probability}</h2>
                                                                                </div>}

                                                                        </div>
                                                                        : ""}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">

                                                            <h5>Microscope Camera Access</h5>

                                                            <video
                                                                ref={this.videoRef}
                                                                width="100%"
                                                                height="auto"
                                                                autoPlay
                                                                style={{ filter: "grayscale(0%) brightness(130%) contrast(90%)", }}
                                                            ></video>
                                                            <canvas ref={this.canvasRef} style={{ display: "none" }}></canvas>
                                                            {/* {errors.validationError && (
                                                                <span className="text-danger form_label">{errors.validationError}</span>
                                                            )} */}
                                                            {errors.validationError && touched.validationError ? (<span className='text-danger form_label' >{errors.validationError}</span>) : null}

                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                <div>
                                                                    <label className='text-end me-2 add_btn' type='button'
                                                                        onClick={() => {
                                                                            this.captureImage(setFieldValue);
                                                                            setFieldValue('imgFile', '');
                                                                            this.setState({ fileImage: '' });
                                                                        }}>Capture Image</label>
                                                                </div>
                                                                <h4>OR</h4>

                                                                <div>
                                                                    <input type='file'
                                                                        id="imgFile"
                                                                        name='imgFile'
                                                                        // onChange={(e) => {
                                                                        //     setFieldValue("imgFile", e.currentTarget.files[0]);
                                                                        //     handleImageChange()

                                                                        // }}
                                                                        onChange={(e) => {
                                                                            this.handleImageChange(e, setFieldValue);
                                                                            setFieldValue('captureImg', '');
                                                                            this.setState({ capturedImage: '' })
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        className='file'
                                                                        style={{ display: 'none' }}
                                                                    />

                                                                    <label className=' ms-2  add_btn' htmlFor="imgFile">Image Upload </label>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </Col>
                                <Col xl='12'>
                                    <div className="row">
                                        <div className="col-md-6">
                                            {reportRes?.type === 1 ?
                                                <div className="prediction_sec ">
                                                    <img src={`data:image/jpeg;base64,${reportRes?.data?.output_image}`} alt="Base64 Example" style={{ width: "100%", height: "auto" }} />
                                                </div> : ''}
                                        </div>
                                        <div className="col-md-6">
                                            {capturedImage || fileImage ?
                                                <div className="prediction_sec ">
                                                    <img
                                                        src={capturedImage ? capturedImage : fileImage}
                                                        alt="Captured"
                                                        style={{ width: '100%', height: 'auto' }} // Adjust to fit container
                                                    />
                                                </div> : ''
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xl='6'>
                                    <PossibleDisease predictionsRes={this.state.predictionsRes} />
                                </Col>
                            </Row>}
                    </Container>
                </div>
                <ToastContainer />
            </>
        );
    }
}
const mapStateToProps = state => ({
    DoctorList: state?.DoctorList?.data?.data,
    PatientList: state?.PatientList?.data?.data,
    TestList: state?.TestList?.data?.data
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(BloodTextReport);








{/* <div className="col-md-12">
                                                                <Dropzone
                                                                    onDrop={(acceptedFiles) => {
                                                                        setFieldValue('file', acceptedFiles[0]); // Set the file value in Formik
                                                                    }}
                                                                    maxFiles={1} // Allow only one file
                                                                    multiple={false} // Disable multiple file selection
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <section className="container-fluid">

                                                                            <div {...getRootProps({ className: 'dropzone' })} style={{ backgroundColor: 'rgb(228, 228, 228)', minHeight: '150px' }}>
                                                                                <input {...getInputProps()} name='Imgfile' />
                                                                                <div className=' pt-2  mt-1'>
                                                                                    <div className='d-flex justify-content-center align-items-center' style={{ height: '60px' }}>
                                                                                        <img src={upload} alt="" style={{ maxHeight: '100%' }} /></div>
                                                                                    <p className='d-flex justify-content-center align-items-center' style={{ color: 'grey', fontSize: '15px' }}>Drag &#39;n&#39; drop a file here, or click to select a file</p>
                                                                                </div>

                                                                            </div>
                                                                            {errors.file && touched.file ? (
                                                                                <div className="text-danger">{errors.file}</div>
                                                                            ) : null}
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <aside className='mt-2'>
                                                                                    <h4>Selected File</h4>
                                                                                    <ul>
                                                                                        {file ? (
                                                                                            <li key={file.name}>
                                                                                                {file.name} - {file.size} bytes
                                                                                            </li>
                                                                                        ) : (
                                                                                            <li>No file selected</li>
                                                                                        )}
                                                                                    </ul>

                                                                                </aside>
                                                                             
                                                                            </div>
                                                                        </section>
                                                                    )}
                                                                </Dropzone>
                                                            </div> */}